import { useMutation } from "react-query";
import { getActivityHistoryById } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetActivityHistoryById = () => {
  return useMutation(getActivityHistoryById);
};
export default useGetActivityHistoryById;
